import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post } = request;
const { Authorization, Bearer } = AUTHORIZATION;

// http://localhost:4000/api/v1/email/send-with-db-attachment
const initialRoute = "email";

export const emailBrochure = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		// console.log("Payload", payload);
		const endpoint = `${initialRoute}/send-with-db-attachment`;
		const token = localStorage.getItem("@jwt_member");
		// console.log("Token", token);
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			// console.log("response", response);
			const {
				data: { message }
			} = response;
			// return message;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const emailBrochureV2 = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		// console.log("Payload", payload);
		const endpoint = `${initialRoute}/send-with-static-attachment`;
		const token = localStorage.getItem("@jwt_member");
		// console.log("Token", token);
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			// console.log("response", response);
			const {
				data: { message }
			} = response;
			// return message;
			if (message === MESSAGE.post.succ) {
				const { status } = response;
				return status;
			}
		}
		throw new Error();
	} catch (error: any) {
		// // console.log("Error", error);
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const emailBrochureVEBEnrollment = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		// console.log("Payload", payload);
		const endpoint = `${initialRoute}/send-with-static-attachment`;
		const token = localStorage.getItem("@jwt_member");
		// console.log("Token", token);
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			// console.log("response", response);
			const {
				data: { message }
			} = response;
			// return message;
			if (message === MESSAGE.post.succ) {
				const { status } = response;
				return status;
			}
		}
		throw new Error();
	} catch (error: any) {
		// // console.log("Error", error);
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const scheduleAppointment = async (_payload: { date_time: string }) => {
	try {
		const payload = JSON.stringify(_payload);
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/send-email-schedule-appointment`;
		const response = await post(endpoint, _payload, {
			Authorization: `Bearer ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};
